// The app calls its API on its own origin (relative URLs), so one build runs
// on any domain. In development, src/setupProxy.js forwards API calls from
// :3000 to the backend on :3001. REACT_APP_API_URL points a build at an API
// elsewhere; normally leave it unset.
const apiBase = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

const config = { apiBase };

export default config;
